module.exports = __webpack_public_path__ + "img/DesenharPoligonos.fa6e8a6c.png";